<template>
  <div class="c-base-partners-shopping">
    <img :class="{ bordered: withBordered }" :src="imgPonto" alt="Ponto" />
    <img
      :class="{ bordered: withBordered }"
      :src="imgCamicado"
      alt="Camicado"
    />
    <img
      :class="{ bordered: withBordered }"
      :src="imgPolishop"
      alt="Polishop"
    />
    <img :class="{ bordered: withBordered }" :src="imgMagalu" alt="Magalu" />
    <img
      :class="{ bordered: withBordered }"
      :src="imgCasasBahia"
      alt="Casas Bahia"
    />
    <img
      :class="{ bordered: withBordered }"
      :src="imgFastShop"
      alt="Fast Shop"
    />
    <img :class="{ bordered: withBordered }" :src="imgExtra" alt="Extra" />
  </div>
</template>

<script>
import imgPonto from '@/assets/img/gifts/external-gift-list/convincing-partner-stores/ponto.png'
import imgCamicado from '@/assets/img/gifts/external-gift-list/convincing-partner-stores/camicado.png'
import imgPolishop from '@/assets/img/gifts/external-gift-list/convincing-partner-stores/polishop.png'
import imgMagalu from '@/assets/img/gifts/external-gift-list/convincing-partner-stores/magalu.png'
import imgCasasBahia from '@/assets/img/gifts/external-gift-list/convincing-partner-stores/casas-bahia.png'
import imgFastShop from '@/assets/img/gifts/external-gift-list/convincing-partner-stores/fast-shop.png'
import imgExtra from '@/assets/img/gifts/external-gift-list/convincing-partner-stores/extra.png'

export default {
  props: {
    withBordered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      imgPonto,
      imgCamicado,
      imgPolishop,
      imgMagalu,
      imgCasasBahia,
      imgFastShop,
      imgExtra,
    }
  },
}
</script>

<style lang="scss">
.c-base-partners-shopping {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: -8px -8px 0;
  padding: 0 32px;
  > img {
    max-width: 56px;
    margin: 8px 4px 0;

    &.bordered {
      border-radius: 8px;
      border: 1px solid #f2f2f2;
    }
  }
  @media screen and (min-width: 768px) {
    margin: -16px -16px 0;
    > img {
      max-width: 68px;
      margin: 16px 8px 0;
    }
  }
}
</style>
